
export default function ServiceDetail() {
  const services = [
    {
      id: 'residential',
      icon: 'ri-home-4-line',
      title: '住宅リフォーム',
      subtitle: '快適な住まいづくりをサポート',
      description: 'キッチン、バスルーム、トイレ、内装、外装など、住宅全般のリフォーム工事を承ります。お客様のライフスタイルに合わせた最適なプランをご提案いたします。',
      features: [
        'キッチン・システムキッチン交換',
        'バスルーム・ユニットバス交換',
        'トイレ・洗面台リフォーム',
        '内装・クロス張替え',
        '外壁・屋根塗装',
        'フローリング・畳交換'
      ],
      targetCustomers: [
        '築年数が経過した住宅にお住まいの方',
        '水回り設備の老朽化でお困りの方',
        '間取り変更をお考えの方',
        'バリアフリー化をご希望の方'
      ],
      image: 'https://public.readdy.ai/ai/img_res/415b131024850975928bf6f261ae91cf.jpg'
    },
    {
      id: 'commercial',
      icon: 'ri-store-2-line',
      title: '店舗工事',
      subtitle: 'お客様に愛される店舗づくり',
      description: '飲食店、美容室、オフィス、クリニックなど、様々な業種の店舗新装・改装工事を手がけています。集客力向上につながる魅力的な店舗空間を創造します。',
      features: [
        '飲食店の新装・改装工事',
        '美容室・サロンの内装工事',
        'オフィス・事務所のレイアウト変更',
        'クリニック・医院の改装',
        '店舗看板・サイン工事',
        '厨房設備・什器工事'
      ],
      targetCustomers: [
        '新規開業をお考えの事業者様',
        '店舗の集客力向上を図りたい方',
        'オフィス環境を改善したい企業様',
        'ブランドイメージを向上させたい方'
      ],
      image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20Japanese%20restaurant%20interior%20with%20warm%20wooden%20elements%2C%20comfortable%20seating%20arrangement%2C%20soft%20ambient%20lighting%2C%20clean%20contemporary%20design%2C%20professional%20kitchen%20view%2C%20welcoming%20atmosphere%2C%20high-quality%20materials%20and%20finishes&width=600&height=400&seq=commercial1&orientation=landscape'
    },
    {
      id: 'repair',
      icon: 'ri-tools-line',
      title: '修繕工事',
      subtitle: '建物の価値を維持・向上',
      description: '雨漏り修理、外壁補修、屋根工事など、建物の修繕工事を迅速かつ丁寧に対応いたします。予防保全から緊急対応まで、建物の長寿命化をサポートします。',
      features: [
        '雨漏り修理・防水工事',
        '外壁ひび割れ・剥離補修',
        '屋根瓦・スレート修理',
        '給排水管の修理・交換',
        '電気設備の修理・更新',
        '建具・サッシの調整・交換'
      ],
      targetCustomers: [
        '雨漏りでお困りの建物オーナー様',
        '外壁の劣化が気になる方',
        '設備の不具合でお悩みの方',
        '建物の資産価値を維持したい方'
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20construction%20worker%20performing%20roof%20repair%20work%20with%20safety%20equipment%2C%20quality%20tools%2C%20careful%20attention%20to%20detail%2C%20well-maintained%20building%20exterior%2C%20skilled%20craftsmanship%2C%20maintenance%20and%20restoration%20work&width=600&height=400&seq=repair1&orientation=landscape'
    }
  ];

  return (
    <section className="py-12 sm:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">
            <strong>サービス詳細</strong>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            お客様のニーズに合わせた3つの専門サービスで、理想の空間づくりをトータルサポートいたします
          </p>
        </div>

        <div className="space-y-12 sm:space-y-16">
          {services.map((service, index) => (
            <div key={service.id} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 sm:gap-12 items-center`}>
              <div className="lg:w-1/2 w-full">
                <div className="rounded-lg overflow-hidden shadow-lg">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-64 sm:h-80 object-cover object-top"
                  />
                </div>
              </div>
              
              <div className="lg:w-1/2 w-full">
                <div className="flex items-center mb-3 sm:mb-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                    <i className={`${service.icon} text-xl sm:text-2xl text-teal-600`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl sm:text-2xl font-bold text-gray-900">{service.title}</h3>
                    <p className="text-teal-600 font-medium text-sm sm:text-base">{service.subtitle}</p>
                  </div>
                </div>
                
                <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 leading-relaxed">{service.description}</p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2 sm:mb-3 text-sm sm:text-base">主な工事内容</h4>
                    <ul className="space-y-1.5 sm:space-y-2">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start">
                          <i className="ri-check-line text-teal-600 mr-2 mt-0.5 flex-shrink-0 text-sm sm:text-base"></i>
                          <span className="text-gray-600 text-xs sm:text-sm">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2 sm:mb-3 text-sm sm:text-base">こんな方におすすめ</h4>
                    <ul className="space-y-1.5 sm:space-y-2">
                      {service.targetCustomers.map((customer, idx) => (
                        <li key={idx} className="flex items-start">
                          <i className="ri-user-line text-teal-600 mr-2 mt-0.5 flex-shrink-0 text-sm sm:text-base"></i>
                          <span className="text-gray-600 text-xs sm:text-sm">{customer}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
